import type { OpenAPI } from "simplydo/interfaces";

import SearchParams from "../searchParams";

export const announcements = (api) => ({
  get(
    entity,
    id,
    page,
    success: (
      data: OpenAPI.GET<"/{entity}/{id}/announcements">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/${entity}s/${id}/announcements?page=${page || 1}`,
      null,
      success,
      fail,
    );
  },
  getAudience(
    entity: string,
    id: string,
    data: OpenAPI.POST<"/{entity}/{id}/announcements/audience">["requestBody"],
    success: (
      data: OpenAPI.POST<"/{entity}/{id}/announcements/audience">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/${entity}s/${id}/announcements/audience`,
      data,
      success,
      fail,
    );
  },
  getTemplates(
    entity: string,
    id: string,
    success: (
      data: OpenAPI.GET<"/{entity}/{id}/announcements/templates">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "GET",
      `/${entity}s/${id}/announcements/templates`,
      null,
      success,
      fail,
    );
  },
  getLogs(
    entity: string,
    id: string,
    params: OpenAPI.GET<"/{entity}/{id}/announcements/logs">["parameters"]["query"],
    success: (
      data: OpenAPI.GET<"/{entity}/{id}/announcements/logs">["response"],
    ) => void,
    fail,
  ) {
    const queryParams = new SearchParams(params).toString();
    api.authenticatedRequest(
      "GET",
      `/${entity}s/${id}/announcements/logs?${queryParams}`,
      null,
      success,
      fail,
    );
  },
  create(
    entity: string,
    id: string,
    data: OpenAPI.POST<"/{entity}/{id}/announcements">["requestBody"],
    success: (
      data: OpenAPI.POST<"/{entity}/{id}/announcements">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/${entity}s/${id}/announcements`,
      data,
      success,
      fail,
    );
  },
  update(
    entity: string,
    id: string,
    announcementId: string,
    data: OpenAPI.PUT<"/{entity}/{id}/announcements/{announcement_id}">["requestBody"],
    success: (
      data: OpenAPI.PUT<"/{entity}/{id}/announcements/{announcement_id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "PUT",
      `/${entity}s/${id}/announcements/${announcementId}`,
      data,
      success,
      fail,
    );
  },
  delete(
    entity: string,
    id: string,
    announcementId: string,
    success: (
      data: OpenAPI.DELETE<"/{entity}/{id}/announcements/{announcement_id}">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/${entity}s/${id}/announcements/${announcementId}`,
      null,
      success,
      fail,
    );
  },
  copy(
    data: OpenAPI.POST<"/announcements/copy">["requestBody"],
    success: (data: OpenAPI.POST<"/announcements/copy">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/announcements/copy`,
      data,
      success,
      fail,
    );
  },
  getEmailPreview(
    entity: string,
    id: string,
    data: OpenAPI.POST<"/{entity}/{id}/announcements/preview">["requestBody"],
    success: (
      data: OpenAPI.POST<"/{entity}/{id}/announcements/preview">["response"],
    ) => void,
    fail,
  ) {
    api.authenticatedRequest(
      "POST",
      `/${entity}s/${id}/announcements/preview`,
      data,
      success,
      fail,
    );
  },
});
